import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { defaultOptions, INbDropdownItem, INbDropdownOptions } from '@app/common/basic/models/nb-dropdown';
import { NbValueAccessor } from '@app/common/basic/models/nb-value-accessor';
import { Observable } from 'rxjs';

@Component({
  selector: 'nb-dropdown',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbDropdownComponent),
      multi: true,
    },
  ],
  templateUrl: './nb-dropdown.component.html',
  styleUrls: ['./nb-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbDropdownComponent<T = INbDropdownItem> extends NbValueAccessor<T> implements OnInit, OnChanges {
  @ContentChild('triggerTemplate')
  triggerTemplate: TemplateRef<any>;

  @ContentChild('itemTemplate')
  itemTemplate: TemplateRef<any>;

  @Input()
  data: T[] | Observable<T[]>;

  @Input()
  options: INbDropdownOptions;

  @Output()
  change = new EventEmitter<T>();

  innerOptions: INbDropdownOptions;

  ngOnInit() {
    this.innerOptions = { ...defaultOptions, ...this.options };
    this.innerOptions.itemClass = ['dropdown-item', ...this.innerOptions.itemClass];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.innerOptions = { ...defaultOptions, ...this.options };
    this.innerOptions.itemClass = ['dropdown-item', ...this.innerOptions.itemClass];
  }

  onItemClick(item: T) {
    this.writeValue(item);
    this.change.emit(item);
  }
}
